// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9fc3a67d","84":"c88a7667","247":"2c04dc2c","440":"f461a680","627":"3b024e12","738":"89906d32","834":"cbdd73fe","923":"bffdf3d6"}[chunkId] + ".chunk.js";
};